// @flow
import React, { useEffect, useState } from "react";
import {
	Box,
	Card,
	CardContent,
	Grid, List,
	ListItem,
	Stack,
	Typography,
	Divider
} from "@mui/material";
import { useHistory } from "react-router-dom";
import { getRouteUrl } from "../../../../helpers/getRouteUrl";
import { ROUTE_PAGE_CALCULATIONS_EDIT } from "../../routes/routes";
import { useTranslation } from "react-i18next";
import { CALCULATIONS } from "../../locales/namespaces";
import MainCard from "../../../../theme/mantis/components/mainCard";
import axios from "axios";
import { API } from "../../../../helpers/constants";
import { enqueueSnackbar } from "notistack";
import { handleAxiosErrors, logoutUnauthorizedUser } from "../../../../helpers/errorHandling";
import useUserData from "../../../../hooks/user/useUserData";
import useUserAction from "../../../../hooks/user/useUserAction";
import { textTranslate } from "../../../../helpers/helpers";
import { TypeInterestRate } from "../../../../parameters/parameters";
import { NumericFormat } from "react-number-format";
import CalculatorBlueIcon from "../../../../assets/images/icons/menuIcons/calculatorBlueIcon";
import DeleteIcon from "../../../../assets/images/icons/buttonsIcons/deleteIcon";
import ShowIcon from "../../../../assets/images/icons/buttonsIcons/showIcon";
import AccordionDots from "../../../../assets/images/icons/accordionDots";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import { Height } from "@mui/icons-material";
import { showPopup } from '../../../../../src/components/globalPopup/globalPopupService';
import ContentLoader from "../../../../components/contentLoader/contentLoader";

const IndexListCalculations = ({ gridItems }) => {
	const { t } = useTranslation(CALCULATIONS)
	const { token, isLoggedIn } = useUserData()
	const { userLogout } = useUserAction()
	const [data, setData] = useState([])
	const [updateData, setUpdateData] = useState(false)
	const { language, decimalSeparator, thousandSeparator } = useUserData()
	const history = useHistory()
	const [loading, setLoading] = useState(false)
	useEffect(() => {
		setLoading(true)
		axios({
			method: 'post',
			headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
			url: `${API}/calculation/indexTable/data`,
		}).then(response => {
			const results = response.data;
			setData(results.results);
			setLoading(false)
		}).catch(error => {
			enqueueSnackbar(handleAxiosErrors(error, t('Failed to get details.')), {
				variant: 'error'
			}
			)
			logoutUnauthorizedUser(error, isLoggedIn, userLogout)
			setLoading(false)
		})
	}, [updateData])

	const handleDelete = (id) => {
		axios({
			method: 'post',
			headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
			url: `${API}/calculation/remove`,
			data: {
				id: id
			}
		}).then(() => {
			// enqueueSnackbar(t('Calculation deleted successfully!'), {
			// 	variant: 'success'
			// })

			showPopup({
				title: '',
				message:  t('Calculation deleted successfully!'),
				onConfirm: () => {
			
				}
			});
			setUpdateData(!updateData)
		}).catch(error => {
			setUpdateData(!updateData)
			enqueueSnackbar(handleAxiosErrors(error, t('Failed to delete calculation!')), {
				variant: 'error'
			}
			)
			logoutUnauthorizedUser(error, isLoggedIn, userLogout)
		})
	}

	const getDescriptionByTypeId = (TypeId) => {
		const type = TypeInterestRate.find(item => item.id === parseInt(TypeId, 10));
		return type ? textTranslate(language)({
			en: type.DescriptionEn,
			el: type.DescriptionEl
		}) : '';
	}

	return  !loading ? (
		<Box sx={{ mb: 2 }}>
			{data.length <= 0 &&
				<Card sx={{ mb: 2, mr: 2, ml: 2,  mt: { xs: '20px', sm: 0 } }}>
					<CardContent>
						<Typography
							style={{ textAlign: 'center' }}
						>
							{t('No loan scenarios have been added yet.')}
						</Typography>
					</CardContent>
				</Card>
			}
			<Box sx={{ display: 'block' }}>
				<Grid container spacing={2}>
					{data.map((item, index) => (
						<Grid item xs={12} sm={6} md={6} lg={parseInt(gridItems)} key={index} >
							<Box sx={{ backgroundColor: 'white', borderRadius: '8px' }}>
								<MainCard sx={{
									boxShadow: '0px 1px 9px 0px #CAD1E5',
									mt:{
										xs:'0',
										sm:'16px',
										md:'16px',
									},
									padding: '0 !important',
									'& .MuiCardContent-root':{
										padding: {
											xs:'16px',
											sm:'16px',
											md:'20px',
										}
									}
								}}>

									<Stack sx={{ backgroundColor: '#F5F7FC', padding: '10px', borderRadius: '8px', lineHeight: '0', width: 'fit-content' }}>
										<CalculatorBlueIcon />
									</Stack>


									<Stack>
										<Typography className="color-secondary p-xsfs" sx={{ margin: '20px 0 12px 0' }}>
											{t('Scenario description')}
										</Typography>
										<Typography className="color-default title-xsm" 
											sx={{
												'&.title-xsm':{fontSize:{xs:'18px !important',sm:'20px !important'}
											}}}>
											{item.Description ? item.Description : '-'}
										</Typography>
									</Stack>


								</MainCard>
								<Box>
									<Accordion
										defaultExpanded
										sx={{
											backgroundColor: 'transparent',
											border: 'none',
											boxShadow:'-4px 0px 6px -4px #CAD1E5,4px 0px 6px -4px #CAD1E5',
											'&.Mui-expanded':{margin:'0'},
											'.MuiAccordionSummary-root': {
												background: 'transparent'
											}
										}}
									>
										<AccordionSummary expandIcon={<AccordionDots />} sx={{
											flexDirection: 'row',
											'& .MuiAccordionSummary-expandIconWrapper': {
												transform: 'rotate(0deg)',
												transition: 'none',
												backgroundColor: 'white',
												border: '0.6px solid #DAE0F0',
											},

											'&.Mui-expanded .MuiAccordionSummary-expandIconWrapper': {
												transform: 'rotate(0deg)',
											},
										}}>
											<Typography className="color-default p-xs">
												{t('Calculation Informations')}
											</Typography>
										</AccordionSummary>


										<AccordionDetails sx={{ border: 'none', paddingTop: '0' }}>

											<Box>
												<Typography className="color-secondary p-xsfs">
													{t('Loan amount (€)')}
												</Typography>
												<NumericFormat
													style={{
														fontSize: '16px',
														fontWeight: "bold"
													}}
													thousandSeparator={thousandSeparator}
													decimalSeparator={decimalSeparator} displayType="text"
													value={item.RequestedAmount ? item.RequestedAmount : '-'}
												/>
											</Box>

											<Box sx={{ paddingTop: '10px' }}>
												<Typography className="color-secondary p-xsfs">
													{t('Interest rate type')}
												</Typography>
												<Typography className="color-default p-sm">
													{getDescriptionByTypeId(item.TypeId)}
												</Typography>
											</Box>

											<Box sx={{ paddingTop: '10px' }}>
												<Typography className="color-secondary p-xsfs">
													{t('Next loan installment is in')}
												</Typography>
												{item.NextInstallment > Number(item.NotificationDays) || item.NextInstallment === null ?
													<Typography
														variant={'bodyMedium'}
														sx={{ fontWeight: item.NextInstallment ? "bold" : 'none' }}
													>
														{item.NextInstallment ? item.NextInstallment + " " + t("days") : '-'}
													</Typography> :
													item.NextInstallment === Number(item.NotificationDays) || item.NextInstallment < Number(item.NotificationDays) || item.NextInstallment === 0 ?
														<Typography
															variant={'bodyMedium'}
															color={'error'}
															sx={{ fontWeight: "bold" }}
														>
															{item.NextInstallment + " " + t(Number(item.NextInstallment) === 1 ? "day" : "days")}
														</Typography> : '-'
												}
											</Box>
										</AccordionDetails>
									</Accordion>


									<Box sx={{
										boxShadow: '0px 1px 9px 0px #CAD1E5',
										borderRadius: '0 0 8px 8px',
									}}>
										<Box className="flex-center" sx={{ alignItems:'stretch' }}>
											<Box
												className="flex-center color-btn-view btn-secondary p-xs"
												sx={{
													cursor: 'pointer',
													padding: '20px 0',
													textAlign: 'center',
													width: '100%',
													height: '100%',
													borderRadius: '0 0 0 9px',
													'& svg': {
														width: '18px',
														marginRight: '8px',
													},
													'& svg g': {
														stroke: '#0BC1B6',
													},
												}}
												onClick={() => history.push(getRouteUrl(ROUTE_PAGE_CALCULATIONS_EDIT, { id: item.id }))}
											>
												<ShowIcon /> {t('View')}
											</Box>

											<Divider
												orientation="vertical"
												flexItem
												sx={{
													borderColor: '#DAE0F0',
												}}
											/>

											<Box
												className="flex-center p-xs btn-delete"
												sx={{
													cursor: 'pointer',
													color: '#A7605B',
													padding: '20px 0',
													width: '100%',
													height: '100%',
													borderRadius: '0 0 9px 0',
													'& svg': {
														width: '18px',
														marginRight: '8px',
													},
													'& svg path': {
														stroke: '#A7605B',
													},
												}}
												onClick={() => handleDelete(item.id)}
											>
												<DeleteIcon style={{ height:'17px' }} /> {t('Delete')}
											</Box>
										</Box>

									</Box>


								</Box>
							</Box>

						</Grid>
					))}
				</Grid>
			</Box>
		</Box>
	) : (
		<ContentLoader
			withBackDrop={true}
			useCircularLoader={true}
			loading={loading}
			message={t("Loading... Please don't close the browser before the process ends.")}
		/>
	)
}

export default IndexListCalculations